import "../styles/siloCube.css";
import { cropStyle } from "@/lib/siloCubeFaces";
import { edgeRenderStyle, isCarve } from "@/lib/edgeStyles";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// SiloArt — renders a silo's center-face cover image + its edge treatment.
// Used on every public surface (public Q&A page, share links, fan portal) so a
// creator's "Silo art" follows the silo everywhere it's displayed. Returns null
// when art is off or there's no cover image (callers fall back to their default).
export default function SiloArt({ cube, enabled = true, className = "", style, rounded = true, "data-testid": testId }) {
  const face = enabled ? cube?.faces?.center : null;
  const imageId = face?.image_id;
  if (!imageId) return null;
  const edge = face.edge_style || "clean";
  const es = edgeRenderStyle(edge, face.edge_amount, face.edge_variance);
  return (
    <div className={`relative overflow-hidden ${rounded ? "rounded-xl" : ""} ${className}`} style={style} data-testid={testId} data-carve={isCarve(edge) ? "1" : "0"}>
      <div className="cube-edge w-full h-full" data-edge={edge} style={es.container}>
        <img src={`${BACKEND_URL}/api/silo-images/${imageId}`} alt="" className="cube-edge-img" draggable={false} style={{ ...cropStyle(face.crop), ...es.img }} />
        {es.overlay && <div className="absolute inset-0 pointer-events-none" style={es.overlay} />}
      </div>
    </div>
  );
}
